export { VuesaxLinearArrowCircleRight2 } from "./VuesaxLinearArrowCircleRight2";
